import { DateUtils } from '../../../utils'

/**
 * Formats playlist data
 * @param {Object} raw
 */
const formatHistoryNotes = ({ created_at, ...raw }) => {
    return {
        ...raw,
        created_at: DateUtils.UTCDateToTimestamp(created_at),
    }
}

/**
 * Formats playlist data
 * @param {Object} raw
 */
const formatHistory = ({ created_at, notes, ...raw }) => {
    return {
        ...raw,
        notes: (notes || []).map(formatHistoryNotes),
        created_at: DateUtils.UTCDateToTimestamp(created_at),
    }
}

// eslint-disable-next-line import/prefer-default-export
export { formatHistory, formatHistoryNotes }
